// extracted by mini-css-extract-plugin
export var active = "_1h-9";
export var backButton = "_1h-8";
export var clone = "_1h-e";
export var collapseBar = "_1h-k";
export var collapseMode = "_1h-m";
export var collapsed = "_1h-o";
export var dimmed = "_1h-i";
export var dragHandle = "_1h-c";
export var dropdownIcon = "_1h-g";
export var expanding = "_1h-n";
export var hidden = "_1h-x";
export var iconContainer = "_1h-q";
export var iconSwapper = "_1h-w";
export var navItem = "_1h-6";
export var navItemIcon = "_1h-f";
export var navProfile = "_1h-7";
export var notificationCountBadge = "_1h-j";
export var notificationDot = "_1h-r";
export var optionsContainer = "_1h-h";
export var primaryNav = "_1h-0";
export var primaryNavDivider = "_1h-v";
export var primaryNavResizeHandle = "_1h-2";
export var primaryNavResizing = "_1h-1";
export var primaryNavTabSection = "_1h-u";
export var primaryTab = "_1h-p";
export var primaryTabIconBox = "_1h-s";
export var secondaryNav = "_1h-3";
export var selected = "_1h-t";
export var settingsNav = "_1h-4";
export var settingsNavItems = "_1h-5";
export var show = "_1h-d";
export var sideNav = "_1h-l";
export var teamItem = "_1h-a";
export var userProfileItem = "_1h-b";